import Reveal from "@/components/base/Reveal";
import { heroStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20abstract%20background%20with%20deep%20crimson%20red%20and%20charcoal%20ink%20shapes%2C%20gold%20foil%20accents%2C%20crumpled%20paper%20texture%2C%20dramatic%20side%20lighting%2C%20film%20grain%2C%20no%20text%2C%20cinematic%20high%20contrast&width=1600&height=1000&seq=hle-hero-main&orientation=landscape"
          alt="黑料曝光网 材料归档主题封面"
          title="黑料曝光 完整时间线材料归档"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/85" />

      <div className="relative mx-auto flex w-full max-w-[1400px] flex-col justify-center px-4 pb-24 pt-16 md:px-8 md:pb-32 md:pt-24">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs tracking-wide text-background-100 backdrop-blur">
            <i className="ri-article-line text-accent-400" />
            黑料曝光网 · 材料归档入口
          </span>
        </Reveal>

        <Reveal delay={80}>
          <h1 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl md:leading-[1.15]">
            黑料曝光 · 从原始材料到关键节点，看清事件背后的真实脉络
          </h1>
        </Reveal>

        <Reveal delay={160}>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            汇总聊天记录、录音证据、内部截图与知情人透露，按完整时间线逐层拆解。
            想知道整个事件是怎么一步步走到今天的？这里把一手内幕细节整理成可检索的材料索引，
            从最先出现的原帖到最新进展，一条不漏。
          </p>
        </Reveal>

        <Reveal delay={240}>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-time-line text-base" />
              进入完整时间线
            </a>
            <a
              href="#evidence"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-folder-download-line text-base" />
              查看证据材料
            </a>
          </div>
        </Reveal>

        <Reveal delay={320}>
          <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur md:mt-16 md:grid-cols-4">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="bg-foreground-950/30 px-5 py-4 md:px-6 md:py-5"
              >
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                    {stat.value}
                  </span>
                  {stat.unit && (
                    <span className="text-sm text-accent-400">{stat.unit}</span>
                  )}
                </div>
                <span className="mt-1 block text-xs tracking-wide text-background-300">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}